import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-issues-preview-banner',
  standalone: true,
  imports: [],
  templateUrl: './issues-preview-banner.component.html',
  styleUrl: './issues-preview-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuesPreviewBannerComponent {
  readonly isVisible = input(true);
  readonly closed = output<void>();

  close(): void {
    this.closed.emit();
  }
}
